import { render } from "./EmailSendModal.vue?vue&type=template&id=0c642f96&ts=true"
import script from "./EmailSendModal.vue?vue&type=script&lang=ts"
export * from "./EmailSendModal.vue?vue&type=script&lang=ts"

import "./EmailSendModal.vue?vue&type=style&index=0&id=0c642f96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__